import { render } from "./IntegrationsListSkeleton.vue?vue&type=template&id=3f489313"
import script from "./IntegrationsListSkeleton.vue?vue&type=script&lang=js"
export * from "./IntegrationsListSkeleton.vue?vue&type=script&lang=js"

import "./IntegrationsListSkeleton.vue?vue&type=style&index=0&id=3f489313&lang=scss"

import exportComponent from "/var/pmweb/builder/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__